export default "__VITE_ASSET__CIFOP7Rx__"